// frontend/src/pages/ActivityLogs.js

import React, { useState, useEffect } from 'react';
import API from '../utils/api';
import { toShamsi } from '../utils/dateHelpers';
import { Pagination } from '../components/common/UI';

export default function ActivityLogs() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1); // پیج‌بندی (صفحه‌بندی سمت کلاینت)
  
  useEffect(() => {
    const fetchLogs = async () => {
      try {
        const response = await API.get('/activity-logs');
        setLogs(response.data.data);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchLogs();
  }, []);
  
  const getActionBadge = (action) => {
    switch(action) {
      case 'CREATE': return <span className="badge bg-green-100 text-green-700">ایجاد</span>;
      case 'UPDATE': return <span className="badge bg-yellow-100 text-yellow-700">ویرایش</span>;
      case 'DELETE': return <span className="badge bg-red-100 text-red-700">حذف</span>;
      default: return <span className="badge bg-blue-100 text-blue-700">مشاهده</span>;
    }
  };
  
  const PAGE_SIZE = 15;
  const totalPages = Math.max(1, Math.ceil(logs.length / PAGE_SIZE));
  const paged = logs.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);

  return (
    <div className="space-y-5 fade-in">
      <h1 className="text-xl font-bold text-gray-800">گزارش فعالیت‌ها</h1>
      
      <div className="glass-card overflow-hidden">
        <div className="overflow-x-auto">
          <table className="premium-table">
            <thead>
              <tr>
                <th>کاربر</th>
                <th>عملیات</th>
                <th>موجودیت</th>
                <th>زمان</th>
                <th>IP</th>
              </tr>
            </thead>
            <tbody>
              {paged.map(log => (
                <tr key={log._id}>
                  <td className="text-gray-800">{log.user?.name || 'ناشناس'}</td>
                  <td>{getActionBadge(log.action)}</td>
                  <td className="text-gray-600">{log.entity}</td>
                  <td className="text-gray-500">{toShamsi(log.createdAt)}</td>
                  <td className="text-gray-500 text-sm">{log.ipAddress || '---'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="px-4">
          <Pagination page={page} totalPages={totalPages} onChange={setPage} />
        </div>
      </div>
    </div>
  );
}